module.exports = __webpack_public_path__ + "img/jsonpath-help1.d4d03216.png";